/* eslint-disable prettier/prettier */
import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import JobList from './JobList';

export default function ManageJobs(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <JobList />
      </MainLayout>
    </div>
  );
}
